import { isEqual } from "utils/util"

import {
  WAREHOUSE_SHELVING_BIN_STATUS,
  WAREHOUSE_SHELVING_BIN_STATUS_LABELS,
  WAREHOUSE_SHELVING_FILTERS_DEFAULT,
} from "./constants"

import { BIN_SIZE_LABELS } from "@/constants/warehouse"
import type { WarehouseShelvingBinSize } from "@/graphql/codegen/graphql"

export const getWarehouseShelvingBinSizeLabel = (binSize: WarehouseShelvingBinSize | string): string =>
  BIN_SIZE_LABELS[binSize] ?? binSize

export const getWarehouseShelvingBinStatusLabel = (
  isAvailable: boolean,
  isDoNotUse: boolean,
  isAllocated: boolean
): string => {
  if (isDoNotUse) return "Do not use"
  if (isAllocated) return "Allocated"
  return isAvailable ? "Available" : "Unavailable"
}

export const getWarehouseShelvingBinStatusColor = (
  isAvailable: boolean,
  isDoNotUse: boolean,
  isAllocated: boolean
): "error" | "primary" | "success" | "warning" => {
  if (isDoNotUse) return "warning"
  if (isAllocated) return "primary"
  return isAvailable ? "success" : "error"
}

// Used to show Chips based on SearchParams values
export const getWarehouseShelvingActiveBinStatusChips = (
  isAvailable: boolean | null | undefined,
  isDoNotUse: boolean | null | undefined
): string => {
  const binStatus = getWarehouseShelvingActiveBinStatusKey(isAvailable, isDoNotUse)
  const labelBinStatus = (binStatus && WAREHOUSE_SHELVING_BIN_STATUS_LABELS[binStatus]) || ""

  return labelBinStatus
}

export const getWarehouseShelvingActiveBinStatusKey = (
  isAvailable: boolean | null | undefined,
  isDoNotUse: boolean | null | undefined
): string | null => {
  if (isDoNotUse) return WAREHOUSE_SHELVING_BIN_STATUS.DO_NOT_USE
  if (isAvailable === true) return WAREHOUSE_SHELVING_BIN_STATUS.AVAILABLE
  if (isAvailable === false) return WAREHOUSE_SHELVING_BIN_STATUS.UNAVAILABLE
  return null
}

export const isWarehouseShelvingFilterEmpty = (
  coldStorage: boolean | null | undefined,
  h3ColdStorage: boolean | null | undefined,
  deep: boolean | null | undefined,
  binSize: WarehouseShelvingBinSize[] | null | undefined,
  isAvailable: boolean | null | undefined,
  isDoNotUse: boolean | null | undefined,
  isUndefined: boolean | null | undefined
): boolean => {
  return (
    coldStorage === WAREHOUSE_SHELVING_FILTERS_DEFAULT.coldStorage &&
    h3ColdStorage === WAREHOUSE_SHELVING_FILTERS_DEFAULT.h3ColdStorage &&
    deep === WAREHOUSE_SHELVING_FILTERS_DEFAULT.deep &&
    isEqual(binSize ?? [], WAREHOUSE_SHELVING_FILTERS_DEFAULT.binSize ?? []) &&
    isAvailable === WAREHOUSE_SHELVING_FILTERS_DEFAULT.isAvailable &&
    isDoNotUse === WAREHOUSE_SHELVING_FILTERS_DEFAULT.isDoNotUse &&
    isUndefined === WAREHOUSE_SHELVING_FILTERS_DEFAULT.isUndefined // Check for undefined filter
  )
}
